// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"solarpanel_110w_animationWrapper__J_g9W"};